module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/img/iot.9ab4a091.svg";